var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBackward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 3709"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 839",
    transform: "rotate(180 12 12)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 418",
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      fill: "#6ea3ce"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 846"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 1235",
    d: "M4.743 9.486 0 4.743 4.743 0",
    style: {
      fill: "none",
      stroke: "#a7cce7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    transform: "translate(7 7.514)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Linie 256",
    transform: "translate(7.435 12.257)",
    style: {
      fill: "none",
      stroke: "#a7cce7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M0 0h9.565"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackward);
export default __webpack_public_path__ + "static/media/arrow-backward.ef14d1dfa167341aad0b8aba45f0b18f.svg";
export { ForwardRef as ReactComponent };